import { Component, OnInit, Inject, NgZone } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Constants } from "./shared/components/language-picker/model/constants.models";
import { MyEvent } from "./shared/components/language-picker/services/myevent.services";
import {
  APP_CONFIG,
  AppConfig,
} from "./shared/components/language-picker/language.config";
import {
  ToastData,
  ToastOptions,
  ToastyConfig,
  ToastyService,
} from "ng2-toasty";
import { OP_CODE, TOAST_TYPE } from "./metadata/interfaces/GuestChecking";
import { IANotificationService } from "./services/ianotification.service";
import { LocalizationHandlerService } from "./services/admin/localization/localization-handler.service";
import { SnackBarService } from "./services/snack-bar/snack-bar.service";
import { HandleFormDirtyService } from "./services/handle-formdirty.service";
import { AuthSignInService } from "./services/authentication/auth-signin.service";
import { UtilService } from "./constants/app.constant";

declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  _Title = "IntegrA Cloud";
  _RtlSide = "left";
  _Position = "bottom-right";
  _Msg: string;
  _ShowClose = true;
  _Theme = "bootstrap";
  _Type = "default";
  _CloseOther = false;

  constructor(
    @Inject(APP_CONFIG) public _Config: AppConfig,
    private _MyEvent: MyEvent,
    private _TranslateService: TranslateService,
    private _Router: Router,
    private _LocalizationHandler: LocalizationHandlerService,
    public _SnackbarService: SnackBarService,
    private _HandleFormDirtyService: HandleFormDirtyService,
    public _AuthSignInService: AuthSignInService,
    private _ToastyService: ToastyService,
    private _Zone: NgZone
  ) {

    this._LocalizationHandler.init();
    IANotificationService.SetCallBack(
      this.PauseSessionForAuthentication.bind(this),
      this.HandleDoorEvents.bind(this)
    );

    //new
    let defaultLang = window.localStorage.getItem(
      Constants.KEY_DEFAULT_LANGUAGE
    );
    this.Globalize(defaultLang);
    this._MyEvent.getLanguageObservable().subscribe((value) => {
      this.Globalize(value);
    });
  }

  Globalize(languagePriority) {
    this._TranslateService.setDefaultLang("en");
    let defaultLangCode = this._Config.availableLanguages[0].code;
    this._TranslateService.use(
      languagePriority && languagePriority.length
        ? languagePriority
        : defaultLangCode
    );
    this.SetDirectionAccordingly(
      languagePriority && languagePriority.length
        ? languagePriority
        : defaultLangCode
    );
  }

  SetDirectionAccordingly(lang: string) {
    switch (lang) {
      case "ar": {
        this._RtlSide = "rtl";
        break;
      }
      default: {
        this._RtlSide = "ltr";
        break;
      }
    }
  }

  

  AddToast(Title: string, Message: string, ToastType: TOAST_TYPE) {
    this._Zone.run(() => {
     
      var toastOptions: ToastOptions = {
        title: Title,
        msg: Message,
        showClose: true,
        timeout: 5000,
        theme: "bootstrap",
        onAdd: (toast: ToastData) => {
          console.log("Toast " + toast.id + " has been added!");
        },
        onRemove: function (toast: ToastData) {
          //console.log('Toast ' + toast.id + ' has been removed!');
        },
      };
      // Add see all possible types in one shot
      switch (ToastType) {
        case TOAST_TYPE.ERROR:
          this._ToastyService.error(toastOptions);
          break;

        case TOAST_TYPE.WARNING:
          this._ToastyService.warning(toastOptions);
          break;

        case TOAST_TYPE.WAIT:
          this._ToastyService.wait(toastOptions);
          break;

        case TOAST_TYPE.SUCCESS:
          this._ToastyService.success(toastOptions);
          break;

        case TOAST_TYPE.INFO:
          this._ToastyService.info(toastOptions);
          break;
      }
    });
  }

  ngOnInit() {
    IANotificationService.SetCallBack(
      this.PauseSessionForAuthentication.bind(this),
      this.HandleDoorEvents.bind(this)
    );

    if (
      UtilService.GetSystemCode(false) != null ||
      UtilService.GetSystemCode(false) != undefined
    ) {
      IANotificationService.HandleNotification();
      this._ToastyService.clearAll();
    }

    this._HandleFormDirtyService.initListener();
    if (sessionStorage.getItem("Reloaded") !== "true") {
      let expiresIn = sessionStorage.getItem("expires")
        ? atob(sessionStorage.getItem("expires"))
        : null;
      if (
        sessionStorage.getItem("token") == null ||
        sessionStorage.getItem("token").length < 10 ||
        expiresIn == null ||
        new Date(expiresIn).getTime() < Date.now()
      ) {
        sessionStorage.clear();
        this._Router.navigate(["/auth/signin"]).then(() => {
          sessionStorage.setItem("Reloaded", "true");
          window.location.reload();
        });
      }
    }

    window.addEventListener("online", () => {
      this._SnackbarService.showSnackBar("You are back Online");
      this._SnackbarService.SetNetworkStatus(true);
      $("#exampleModal").modal("hide");
    });

    window.addEventListener("offline", () => {
      this._SnackbarService.SetNetworkStatus(false);
      $("#exampleModal").modal("show");
    });

  }

  HandleDoorEvents(NotifData: any) {
    if (NotifData?._OpCode !== undefined) {
      var DisplaMsg = "Room : " + "<b>" + NotifData._DoorName + "</b> <br/>";
      DisplaMsg += "Event : " + "<b>" + NotifData._Event + "</b>  <br/>";
      DisplaMsg += "Operator : " + "<b>" + NotifData._Operator + "</b>  <br/>";

      switch (NotifData?._OpCode) {
        case OP_CODE.GRANT_OPEN:
        case OP_CODE.GRANT_BLOCK_OR:
        case OP_CODE.GRANT_PRIV_OR:
        case OP_CODE.GRANT_UNLOCKED_OK:
        case OP_CODE.GRANT_DUMMY:
        case OP_CODE.GRANT_OFFICE:
        case OP_CODE.SYS_ANS_GRANT_BACK_OF_BY_FREE_PASSAGE:
          // this.utilService.dismissToast();
          // this.utilService.presentToast(DisplaMsg, "success", 4000, "checkbox-outline");

          this.AddToast(
            "<b>DOOR NOTIFICATION</b>",
            DisplaMsg,
            TOAST_TYPE.SUCCESS
          );
          break;

        case OP_CODE.GRANT_CANCELLING:
        case OP_CODE.GRANT_BLOCKED:
        case OP_CODE.REJECT_UNKNOWN:
        case OP_CODE.GRANT_UNLOCKED_OK:
        case OP_CODE.REJECT_NO_OPEN:
        case OP_CODE.REJECT_NO_AUT:
        case OP_CODE.REJECT_INI_DATE:
        case OP_CODE.REJECT_EXP_DATE:
        case OP_CODE.NOPIN:
        case OP_CODE.BADPIN:
        case OP_CODE.REJECT_ONE_SHOT_EXP:
        case OP_CODE.REJECT_BLOCKED:
        case OP_CODE.REJECT_OUTSHIFT:
        case OP_CODE.REJECT_USR_DISABLED:
          //alert(DisplaMsg);
          //   this.utilService.dismissToast();
          //  this.utilService.presentToast(DisplaMsg, "danger", 4000, "shield");
          this.AddToast(
            "<b>DOOR NOTIFICATION</b>",
            DisplaMsg,
            TOAST_TYPE.ERROR
          );
          break;

        case OP_CODE.SYS_ANS_DO_NOT_APP_IS_IN_OFFICE:
        case OP_CODE.SYS_ANS_INTEGRA_DATA_NOK:
        case OP_CODE.SYS_ANS_CMD_NOT_WELL_GEN:
        case OP_CODE.SYS_ANS_LOCK_NOT_OFFICE_ENABLED:
        case OP_CODE.SYS_ANS_DO_NOT_APP_IS_BLOCK:
        case OP_CODE.SYS_ANS_DO_NOT_APP_IS_MECH_PRIV:
        case OP_CODE.SYS_ANS_ALREADY_IN_DND:
        case OP_CODE.SYS_ANS_DO_NOT_APP_IS_NOT_IN_THIS_STATE:
        case OP_CODE.SYS_ANS_DO_NOT_APP_IS_IN_SEC_CLOSE:
        case OP_CODE.SYS_ANS_DO_NOT_APP_IS_IN_OFFIRST:
          // this.utilService.dismissToast();
          // this.utilService.presentToast(DisplaMsg, "warning", 4000, "warning-outline");
          this.AddToast(
            "<b>DOOR NOTIFICATION</b>",
            DisplaMsg,
            TOAST_TYPE.ERROR
          );
          break;

        default:
          //  this.utilService.dismissToast();
          //  this.utilService.presentToast(DisplaMsg, "default", 4000, "information-circle");
          this.AddToast("<b>DOOR NOTIFICATION</b>", DisplaMsg, TOAST_TYPE.INFO);
          break;
      }
    }
  }

  PauseSessionForAuthentication(NotifData: any) {}

  HandleCaches(Data: any): void {
    this._SnackbarService.showLoginSnackBar("Notifcation data..", "green");
  }
}
